import { LazyPageLoading } from '@components/lazy-page-loading'
import { loadPaymentBatchPage } from '@pages/payment-batch/payment-batch-loader'
import { lazy, Suspense } from 'react'

const PaymentBatch = lazy(() =>
  loadPaymentBatchPage().then((module) => ({
    default: module.PaymentBatch,
  })),
)

export const PaymentBatchRoute = () => (
  <Suspense fallback={<LazyPageLoading />}>
    <PaymentBatch />
  </Suspense>
)
